import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { PAGE_TITLES } from "../constant";

const PublicRoutes = ({ component: Component, ...rest }) => {
  const location = useLocation();
  // HOOKS
  useEffect(() => {
    const currentLoc = location.pathname;
    let title = "Login";
    if (currentLoc !== "/") {
      title =
        PAGE_TITLES.find((page) => currentLoc.includes(page.key))?.title ?? "404";
    }
    ReactGA.send({
      hitType: "pageview",
      page: currentLoc,
      title: title,
    });
  }, [location]);
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PublicRoutes;
